(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    function getContent() {
      return document.getElementById("cart-drawer-content");
    }

    const PENDING_VALUE = "Updating…";
    let snapshot = null;

    /** Every place a cart renders: the drawer, and the /cart page if we're on it. */
    function cartSurfaces() {
      return [getContent(), document.querySelector("[data-main-cart]")].filter(Boolean);
    }

    function setSyncing(isSyncing) {
      for (const surface of cartSurfaces()) {
        surface.classList.toggle("is-syncing", isSyncing);
        surface.querySelectorAll("[data-cart-subtotal], [data-cart-bond]").forEach((el) => {
          if (isSyncing) {
            if (!("settledValue" in el.dataset)) el.dataset.settledValue = el.textContent;
            el.textContent = PENDING_VALUE;
          } else if ("settledValue" in el.dataset) {
            el.textContent = el.dataset.settledValue;
            delete el.dataset.settledValue;
          }
        });
        surface.querySelectorAll("[data-cart-checkout]").forEach((el) => (el.hidden = isSyncing));
        surface.querySelectorAll("[data-cart-checkout-pending]").forEach((el) => (el.hidden = !isSyncing));
      }
    }

    function badgeCount() {
      const wrap = document.querySelector("[data-cart-count]");
      return wrap ? parseInt(wrap.dataset.cartCount, 10) || 0 : 0;
    }

    /** Optimistic badge — outfits only, never the bond (HYDROGEN's outfitCount). */
    function setBadge(count) {
      document.querySelectorAll("[data-cart-count]").forEach((wrap) => {
        wrap.dataset.cartCount = String(count);
        const badge = wrap.querySelector(".c-header__cart-badge");
        if (badge) badge.textContent = String(count);
        const live = wrap.querySelector("[data-cart-count-live]");
        if (live) live.textContent = count === 1 ? "1 outfit in your cart" : `${count} outfits in your cart`;
      });
    }

    /** Remembers the settled state so a refused change can be put back exactly. */
    function takeSnapshot() {
      if (snapshot) return;
      snapshot = {
        badge: badgeCount(),
        surfaces: cartSurfaces().map((el) => ({ el, html: el.innerHTML })),
      };
    }

    function restoreSnapshot() {
      if (!snapshot) return;
      setBadge(snapshot.badge);
      for (const { el, html } of snapshot.surfaces) {
        if (el.isConnected) el.innerHTML = html;
      }
      snapshot = null;
    }

    /**
     * Drops a line on click, before the server answers (HYDROGEN's
     * useOptimisticCart). A surface left with no outfits — only a bond, or
     * nothing — shows its empty state straight away, the way HYDROGEN's
     * drawer branches on the outfit count.
     */
    function removeLineOptimistically(lineKey) {
      takeSnapshot();
      let removedOutfits = 0;
      for (const surface of cartSurfaces()) {
        surface.querySelectorAll(`.c-cart-line[data-line-key="${CSS.escape(lineKey)}"]`).forEach((row, i) => {
          if (i === 0 && surface === cartSurfaces()[0] && !row.hasAttribute("data-bond-line")) {
            removedOutfits = parseInt(row.dataset.lineQuantity, 10) || 1;
          }
          row.remove();
        });
        const outfitsLeft = surface.querySelectorAll(".c-cart-line:not([data-bond-line])").length;
        const emptyTemplate = surface.querySelector("template[data-cart-empty]");
        if (outfitsLeft === 0 && emptyTemplate) {
          surface.querySelector("[data-cart-filled]")?.replaceWith(emptyTemplate.content.cloneNode(true));
        }
      }
      setBadge(Math.max(0, badgeCount() - removedOutfits));
    }

    function showNotice(notice) {
      const content = getContent();
      const slot = content && content.querySelector("[data-cart-notice-slot]");
      if (!slot) return;
      if (!notice) {
        slot.hidden = true;
        slot.innerHTML = "";
        delete slot.dataset.cartNotice;
        return;
      }
      slot.hidden = false;
      slot.dataset.cartNotice = notice.tone;
      slot.className = `c-cart-notice c-cart-notice--${notice.tone}`;
      slot.setAttribute("role", notice.tone === "error" ? "alert" : "status");
      slot.innerHTML = `<p class="c-cart-notice__message">${notice.message}</p><button type="button" class="c-cart-notice__dismiss" aria-label="Dismiss message" data-dismiss-notice>&times;</button>`;
    }

    document.addEventListener("click", (event) => {
      if (event.target.closest("[data-dismiss-notice]")) showNotice(null);

      // The header's cart icon (outside <chari-drawer id="cart-drawer">) is a
      // plain link to /cart so it works with JS off; with JS on, intercept
      // it to open the drawer instead, matching HYDROGEN's CartToggle.
      const cartOpenTrigger = event.target.closest("[data-cart-open]");
      if (cartOpenTrigger) {
        event.preventDefault();
        window.dispatchEvent(new Event("openCart"));
      }
    });

    // Delegated on `document`, not a per-line custom element (see
    // snippets/cart-line.liquid) — this section is part of overlay-group,
    // so it's guaranteed to run on every page, unlike a script scoped to
    // cart-line.liquid itself, which Shopify only bundles once that snippet
    // has actually been rendered server-side (never true for an empty cart).
    document.addEventListener("submit", async (event) => {
      const form = event.target.closest("[data-cart-line-remove]");
      if (!form) return;
      event.preventDefault();
      const lineKey = form.dataset.lineKey;
      showNotice(null);
      removeLineOptimistically(lineKey);
      const { removeLine } = await import("chari/cart");
      removeLine(lineKey);
    });

    document.addEventListener("chari:cart:pending", (event) => {
      showNotice(null);
      takeSnapshot();
      if (event.detail?.action === "add") setBadge(badgeCount() + 1);
      setSyncing(true);
    });

    document.addEventListener("chari:cart:updated", async (event) => {
      snapshot = null;
      setSyncing(false);
      const { action, outcome, sections } = event.detail || {};
      if (sections && sections["cart-drawer"]) {
        const doc = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
        const freshContent = doc.getElementById("cart-drawer-content");
        const currentContent = getContent();
        if (freshContent && currentContent) currentContent.innerHTML = freshContent.innerHTML;
      }
      if (sections && sections["header"]) {
        const doc = new DOMParser().parseFromString(sections["header"], "text/html");
        const freshHeader = doc.querySelector(".c-header");
        const currentHeader = document.querySelector(".c-header");
        if (freshHeader && currentHeader) currentHeader.outerHTML = freshHeader.outerHTML;
      }
      if (outcome) {
        const { noticeForEvent } = await import("chari/cart-notice");
        showNotice(noticeForEvent({ action, outcome }));
      }
    });

    document.addEventListener("chari:cart:error", async (event) => {
      // The change genuinely didn't happen: put the line (and badge) back,
      // then say why — never a silent snap-back.
      restoreSnapshot();
      setSyncing(false);
      const { action, outcome } = event.detail || {};
      const { noticeForEvent } = await import("chari/cart-notice");
      showNotice(noticeForEvent({ action, outcome }));
    });

    document.addEventListener("chari:drawer-close", (event) => {
      if (event.target && event.target.id === "cart-drawer") showNotice(null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["js-tests"]) return;
  try {
    
  (async () => {
    const { report } = await import("chari/test-runner");

    // Add one import line here for every new assets/chari-tests-*.js module.
    // This tag can't contain Liquid, so the list can't be generated automatically.
    await import("chari/tests-rental");
    await import("chari/tests-dates");
    await import("chari/tests-availability");
    await import("chari/tests-bond");
    await import("chari/tests-cart-result");
    await import("chari/tests-cart-notice");
    await import("chari/tests-search-query");
    await import("chari/tests-collection-params");

    const target = document.getElementById("js-test-results");
    delete target.dataset.pending;
    report(target);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener("chari:cart:updated", async () => {
    const current = document.querySelector("[data-main-cart]");
    if (!current) return;
    try {
      const response = await fetch(`${window.location.pathname}?section_id=${current.dataset.sectionId}`);
      const doc = new DOMParser().parseFromString(await response.text(), "text/html");
      const next = doc.querySelector("[data-main-cart]");
      if (next) current.replaceWith(next);
    } catch (error) {
      console.error("[cart page] re-render failed:", error);
      window.location.reload();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (async () => {
    // Rewrites legacy Hydrogen collection URL parameters
    // (?sortKey=/&reverse=/?size=) still out there in old links — see
    // chari/collection-params and ADR-06/ADR-07. Only loads the module at
    // all when one of those params is actually present.
    if (!/[?&](sortKey|reverse|size)=/.test(location.search)) return;
    const { rewriteCurrentLocation } = await import("chari/collection-params");
    rewriteCurrentLocation();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (async () => {
    const root = document.querySelector(".c-product");
    if (!root) return;

    const [{ getBooking }, dates, cart] = await Promise.all([
      import("chari/booking"),
      import("chari/dates"),
      import("chari/cart"),
    ]);

    const booking = getBooking();
    const isRental = root.dataset.isRental === "true";
    const variantId = Number(root.dataset.variantId);

    function renderBookingUI() {
      const date = booking.date;
      const returnDate = dates.addDays(date, 3);

      root.querySelectorAll("[data-booking-date-long]").forEach((el) => {
        el.textContent = dates.formatDate(date, "do MMMM yyyy");
      });
      root.querySelectorAll("[data-booking-arrives]").forEach((el) => {
        el.textContent = dates.formatDate(date, "EEE d MMM");
      });
      root.querySelectorAll("[data-booking-returns]").forEach((el) => {
        el.textContent = dates.formatDate(returnDate, "EEE d MMM");
      });
      root.querySelectorAll("[data-booking-mobile-summary]").forEach((el) => {
        el.textContent = `Arrives ${dates.formatDate(date, "d MMM")} · ${currentPriceText()}`;
      });
      root.querySelectorAll("[data-booking-policy-date]").forEach((el) => {
        el.textContent = date.toLocaleDateString("en-AU", { dateStyle: "long" });
      });
      root.querySelectorAll("[data-booking-policy-return]").forEach((el) => {
        el.textContent = returnDate.toLocaleDateString("en-AU", { dateStyle: "long" });
      });
    }

    function currentPriceText() {
      const priceEl = root.querySelector(".c-product__price");
      return priceEl ? priceEl.textContent.trim() : "";
    }

    if (isRental) {
      renderBookingUI();
      booking.addEventListener("change", renderBookingUI);
    }

    // --- Add to cart / checkout / confirm drawer wiring (spec §7) ---
    const confirmDrawerEl = document.getElementById("delivery-date-confirm-drawer");
    const confirmDrawerApi = confirmDrawerEl; // the <chari-drawer> custom element itself
    const errorEl = root.querySelector("[data-cart-error]");
    const continueButton = root.querySelector("[data-confirm-continue]");
    const addButton = root.querySelector("[data-add-to-cart]");
    const checkoutButton = root.querySelector("[data-checkout-single]");
    let pendingAction = null;

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = !message;
    }

    function setBusy(busy) {
      if (continueButton) {
        continueButton.disabled = busy;
        continueButton.textContent = busy ? "Processing…" : "Continue";
      }
      if (addButton) addButton.disabled = busy;
      if (checkoutButton) checkoutButton.disabled = busy;
    }

    addButton?.addEventListener("click", () => {
      pendingAction = "addToCart";
      showError(null);
      confirmDrawerApi?.open();
    });

    checkoutButton?.addEventListener("click", () => {
      pendingAction = "checkout";
      showError(null);
      confirmDrawerApi?.open();
    });

    continueButton?.addEventListener("click", async () => {
      if (!pendingAction) return;
      setBusy(true);
      showError(null);

      const payload = { variantId, date: isRental ? booking.date : null };
      const outcome =
        pendingAction === "addToCart" ? await cart.addOutfit(payload) : await cart.checkoutSingle(payload);

      setBusy(false);

      if (pendingAction === "checkout") {
        // A successful checkout navigates away; only a failure returns here.
        if (!outcome.success) showError(outcome.message);
        return;
      }

      if (outcome.success) {
        confirmDrawerApi?.close();
        window.dispatchEvent(new Event("openCart"));
        pendingAction = null;
      } else {
        showError(outcome.message);
      }
    });

    confirmDrawerEl?.addEventListener("chari:drawer-close", () => {
      pendingAction = null;
      showError(null);
    });

    // Most refusal copy points at trying another date, so a message left
    // above a date the customer has since changed would read as a fresh
    // refusal of the new one (HYDROGEN cleared it the same way).
    if (isRental) booking.addEventListener("change", () => showError(null));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (async () => {
    const guidesSlot = document.querySelector("[data-search-guides]");
    const params = new URLSearchParams(window.location.search);
    const term = params.get("q");
    if (!guidesSlot || !term) return;

    const { buildSearchQuery } = await import("chari/search-query");
    const query = buildSearchQuery(term);
    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=page,article&resources[limit]=6`,
      );
      const data = await response.json();
      const pages = (data.resources.results.pages || []);
      const articles = (data.resources.results.articles || []);
      const guides = [...pages, ...articles].slice(0, 6);
      if (guides.length === 0) return;

      const noResults = document.querySelector("[data-search-no-results]");
      if (noResults) {
        noResults.textContent =
          "Nothing in the catalogue matched that, but these pages might help.";
      }

      const heading = document.createElement("section");
      heading.innerHTML = `
        <p class="c-search-page__browse-label" style="margin-top:32px;">Pages &amp; guides</p>
        <ul style="margin:12px 0 0;padding:0;list-style:none;display:flex;flex-direction:column;gap:8px;">
          ${guides.map((g) => `<li><a href="${g.url}" class="c-text-link c-text-link--sm c-text-link--tone-coral">${g.title}</a></li>`).join("")}
        </ul>`;
      guidesSlot.appendChild(heading);
    } catch (error) {
      console.error("[search] guides lookup failed:", error);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  document.querySelectorAll("[data-product-recommendations]").forEach(async (el) => {
    const url = el.dataset.url;
    if (!url) return;
    try {
      const response = await fetch(url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const newContent = doc.getElementById(el.id);
      if (newContent && newContent.innerHTML.trim()) {
        el.outerHTML = newContent.outerHTML;
      } else {
        el.remove();
      }
    } catch (error) {
      console.error("[product-recommendations] failed to load:", error);
      el.remove();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  class PredictiveSearch {
    constructor(form) {
      this.form = form;
      this.input = form.querySelector("[data-predictive-search-input]");
      this.resultsEl = form.querySelector("[data-predictive-search-results]");
      this.idleHtml = this.resultsEl ? this.resultsEl.innerHTML : "";
      this.abortController = null;
      this.debounceTimer = null;
      this.input?.addEventListener("input", (event) => this.handleInput(event.target.value));
    }

    handleInput(value) {
      clearTimeout(this.debounceTimer);
      const term = value.trim();
      if (!term) {
        this.resultsEl.innerHTML = this.idleHtml;
        return;
      }
      this.resultsEl.innerHTML = `<div class="c-search-drawer__loading"><span>Loading outfits…</span></div>`;
      this.debounceTimer = setTimeout(() => this.search(term), 200);
    }

    async search(term) {
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      const { buildSearchQuery } = await import("chari/search-query");
      const query = buildSearchQuery(term);
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=hide`;

      try {
        const response = await fetch(url, { signal: this.abortController.signal });
        const data = await response.json();
        this.render(data.resources.results, term);
      } catch (error) {
        if (error.name !== "AbortError") console.error("[search] predictive search failed:", error);
      }
    }

    render(results, term) {
      const products = results.products || [];
      const collections = results.collections || [];
      const pages = results.pages || [];
      const articles = results.articles || [];
      const total = products.length + collections.length + pages.length + articles.length;

      if (total === 0) {
        this.resultsEl.innerHTML = `
          <div class="c-search-drawer__empty">
            <p class="c-text c-text--tone-strong c-text--weight-600">No results found</p>
            <p class="c-text c-text--sm" style="margin-top:4px;">Try searching the outfits by their name.</p>
          </div>`;
        return;
      }

      let html = "";
      if (products.length) {
        html += `<div class="c-search-drawer__group"><p class="c-menu-list__label">Outfits · ${products.length}</p><ul>`;
        html += products
          .map((p) => {
            const img = p.image ? `<img class="c-search-drawer__product-image" src="${p.image}" alt="" width="38" height="50">` : "";
            return `<li class="c-search-drawer__product-item"><a href="${p.url}">${img}<span><span class="c-search-drawer__product-title">${p.title}</span><span class="c-search-drawer__product-meta">${p.price}</span></span></a></li>`;
          })
          .join("");
        html += `</ul></div>`;
      }
      if (collections.length) {
        html += `<div class="c-search-drawer__group"><p class="c-menu-list__label">Collections · ${collections.length}</p><ul>`;
        html += collections.map((c) => `<li><a href="${c.url}" class="c-menu-list__link c-menu-list__link--sm c-menu-list__link--tone-coral"><span>${c.title}</span></a></li>`).join("");
        html += `</ul></div>`;
      }
      const guides = [...pages, ...articles];
      if (guides.length) {
        html += `<div class="c-search-drawer__group"><p class="c-menu-list__label">Pages &amp; guides · ${guides.length}</p><ul>`;
        html += guides.map((g) => `<li><a href="${g.url}" class="c-menu-list__link c-menu-list__link--sm c-menu-list__link--tone-coral"><span>${g.title}</span></a></li>`).join("");
        html += `</ul></div>`;
      }
      if (products.length) {
        html += `<div class="c-search-drawer__see-all"><a href="/search?q=${encodeURIComponent(term)}" class="c-text-link c-text-link--sm c-text-link--tone-coral">See all results for "${term}"</a></div>`;
      }

      this.resultsEl.innerHTML = html;
    }
  }

  document.querySelectorAll("[data-predictive-search-form]").forEach((form) => {
    if (!form.dataset.predictiveSearchBound) {
      form.dataset.predictiveSearchBound = "true";
      new PredictiveSearch(form);
    }
  });

  // The header's search icon (outside <chari-drawer id="search-drawer">) is
  // a plain link to /search so it works with JS off; intercept it here.
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-search-open]");
    if (trigger) {
      event.preventDefault();
      window.dispatchEvent(new Event("openSearch"));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
